import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon, Url } from '#const';
import { getIconUrl } from '#utils';

const ThreeColumn = dynamic(() => import('./ThreeColumn'));

Builder.registerComponent(ThreeColumn, {
	name: 'ThreeColumn',
	inputs: [
		{
			name: 'heading',
			friendlyName: 'Heading',
			type: 'richText',
			required: false,
			defaultValue: '<h2>Time is limited - Fill out the form to see if you qualify!</h2>',
		},
		{
			name: 'copy',
			friendlyName: 'Text',
			type: 'richText',
			defaultValue: '<p>Placeholder body text.</p>',
		},
		{
			name: 'cardStyling',
			friendlyName: 'Card Styling',
			type: 'boolean',
			defaultValue: false,
			helperText: 'Style the columns with card outlines?',
		},
		{
			name: 'alignCenter',
			friendlyName: 'Center Align',
			type: 'boolean',
			defaultValue: false,
			helperText: 'Center align content when not using card styling',
			showIf: function (options) {
				return !options.get('cardStyling');
			},
		},
		{
			name: 'backgroundColor',
			friendlyName: 'Background Color',
			type: 'color',
			defaultValue: '#F9FAFB',
			helperText: 'Be sure to select a color light enough for the text to have contrast.',
		},
		{
			name: 'columns',
			friendlyName: 'Columns',
			type: 'list',
			subFields: [
				{
					name: 'image',
					friendlyName: 'Image',
					type: 'file',
					allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
				},
				{
					name: 'columnHeading',
					friendlyName: 'Column Heading',
					type: 'richText',
				},
				{
					name: 'columnCopy',
					friendlyName: 'Column Text',
					type: 'richText',
				},
				{
					name: 'horizontalRule',
					friendlyName: 'Horizontal Rule',
					type: 'boolean',
					defaultValue: false,
					helperText: 'Should there be a horizontal rule between text and heading?',
				},
				{
					name: 'hrColor',
					friendlyName: 'Horizontal Rule Color',
					type: 'color',
					defaultValue: '#FEDE49',
					// eslint-disable-next-line object-shorthand
					showIf: function (options) {
						return options.get('horizontalRule') === true;
					},
				},
			],
			// eslint-disable-next-line @typescript-eslint/no-explicit-any, object-shorthand
			onChange: function (options: any) {
				if (options.get('columns').length > 3) {
					options.set('columns', options.get('columns').slice(0, 3));
					alert('Maximum items is 3, delete item to continue.');
				}
			},
			defaultValue: [
				{
					image: Url.PLACEHOLDER,
					columnCopy: '<p>Placeholder body text.</p>',
				},
				{
					image: Url.PLACEHOLDER,
					columnCopy: '<p>Placeholder body text.</p>',
				},
				{
					image: Url.PLACEHOLDER,
					columnCopy: '<p>Placeholder body text.</p>',
				},
			],
		},
		{
			name: 'lockImageSize',
			friendlyName: 'Lock Image Size',
			type: 'boolean',
			defaultValue: false,
			helperText: 'Make all images appear the same size',
		},
		{
			name: 'lowerCopy',
			friendlyName: 'Lower Copy',
			type: 'richText',
			required: false,
		},
		{
			name: 'circularImages',
			friendlyName: 'Circular Images',
			type: 'boolean',
			defaultValue: false,
			helperText: 'Display images in circular frames',
		},
	],
	canHaveChildren: true,
	defaultChildren: [
		{
			'@type': '@builder.io/sdk:Element',
			component: {
				name: 'Button',
				options: {
					copy: 'See if I Qualify',
					arrow: true,
					color: 'rgba(17, 186, 0, 1)',
				},
			},
		},
	],
	childRequirements: {
		message: 'Child must be a Button.',
		query: { 'component.name': { $eq: 'Button' } },
	},
	image: getIconUrl(Icon.COLUMNS),
});
